import React, { useState, useEffect } from 'react';
import AppIcon from '../common/AppIcon';
import './Header.css';

const NAV_ITEMS = [
  { id: 'schedule', label: 'Schedule', icon: 'schedule' },
  { id: 'doctors', label: 'Doctors', icon: 'doctors' },
  { id: 'hospitals', label: 'Hospitals', icon: 'hospitals' },
  { id: 'slots', label: 'Slot Management', icon: 'slots' },
  { id: 'availability', label: 'Availability', icon: 'availability' },
  { id: 'analytics', label: 'Analytics', icon: 'analytics' },
  { id: 'settings', label: 'Settings', icon: 'settings' },
];

const Header = () => {
  const [activeTab, setActiveTab] = useState('schedule');

  useEffect(() => {
    const updateActiveTab = () => {
      const hash = window.location.hash.replace('#', '') || 'schedule';
      setActiveTab(hash);
    };

    updateActiveTab();
    window.addEventListener('hashchange', updateActiveTab);
    return () => window.removeEventListener('hashchange', updateActiveTab);
  }, []);

  const handleNavClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <header className="header">
      <div className="header-content">
        <div className="header-title">
          <div className="header-logo icon-badge icon-badge--md icon-badge--white">
            <AppIcon name="logo" size={28} strokeWidth={2.25} className="app-icon--white" />
          </div>
          <div className="title-content">
            <h1 className="main-title">Doctor Schedule Manager</h1>
            <div className="header-subtitle">
              <span className="subtitle-text">AI-Powered Medical Staff Scheduling</span>
            </div>
          </div>
        </div>
        
        <nav className="header-nav">
          {NAV_ITEMS.map(({ id, label, icon }) => (
            <a
              key={id}
              href={`#${id}`}
              className={`header-nav-item ${activeTab === id ? 'active' : ''}`}
              onClick={() => handleNavClick(id)}
            >
              <span className="nav-icon-wrap">
                <AppIcon name={icon} size={22} strokeWidth={2.25} />
              </span>
              <span className="nav-text">{label}</span>
            </a>
          ))}
        </nav>
      </div>
    </header>
  );
};

export default Header;
